import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as CookieService from '../CookieService';
import * as $ from 'jquery';
import * as MenuAction from './MenuAction';

const tokenExpired = async () => {
    try {
        let tokenExpiredData = { type: "Token_Expired", response: true };
        Dispatcher.dispatch(tokenExpiredData);

    } catch (ex) {
        console.log(ex)

    }
};
const PageLoad = (PageLoadBo) => {
    try {
        debugger;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.EquipmentParts,
            SDIConstants.methodNames.EquipmentParts_PageLoad,
            JSON.stringify(PageLoadBo),
            (data) => {
                if (data.success) {
                    debugger
                    if (data.response != "" && data.response) {
                        let contentData = { type: "EqipmentPageLoad", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const onChangeValues = (resultBO) => {
    try {
        debugger;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Searchpage,
            SDIConstants.methodNames.Searchpage_Page_Load,
            JSON.stringify(resultBO),
            (data) => {
                if (data.success) {
                    debugger
                    if (data.response != "" && data.response) {
                        let contentData = { type: "EqipmentSearchResult", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const EquipmentaddCLick = (EquipmentBO) => {
    try {
        debugger;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Searchpage,
            SDIConstants.methodNames.Searchpage_Page_Load,
            JSON.stringify(EquipmentBO),
            (data) => {
                if (data.success) {
                    debugger
                    if (data.response != "" && data.response) {
                        let contentData = { type: "AddToClick", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const WOcheck = async (WorkorderBO) => {
    try {
        SDISVC.callAsync(
            SDIConstants.moduleNames.ServiceChannel,
            SDIConstants.methodNames.ServiceChannel_GetStoreData,
            JSON.stringify(WorkorderBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        let contentData = { type: "EquipmentWorkOrder", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }

                    else {
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        let contentData = { type: "workorderfail", response: "fail" };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};



export {
    PageLoad, onChangeValues, EquipmentaddCLick, WOcheck
}